import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setOverChargeClaimTypeList } from '../common/CommonActions';
import { getOverChargeClaimTypeListEffect } from '../Claims/OverCharge/OverChargeEffects';

const useOverChargeClaimTypeList = () => {
  const [list, setList] = useState(undefined);
  const { overChargeClaimTypeList } = useSelector((state) => state.common);
  const dispatch = useDispatch();

  useEffect(() => {
    if (overChargeClaimTypeList.success) {
      setList(overChargeClaimTypeList.data);
    } else {
      getList();
    }
  }, [overChargeClaimTypeList]);

  const getList = async () => {
    try {
      dispatch(setOverChargeClaimTypeList({ success: true, data: [] }));
      const { data } = await getOverChargeClaimTypeListEffect();
      setList(data);
      dispatch(setOverChargeClaimTypeList({ success: true, data }));
    } catch (error) {
      setList([]);
    }
  };

  return list;
};

export default useOverChargeClaimTypeList;
